import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Web3ReactProvider } from "@web3-react/core";
import {
  ExternalProvider,
  JsonRpcFetchFunc,
  Web3Provider,
} from "@ethersproject/providers";
import { GoogleOAuthProvider } from "@react-oauth/google";
import ErrorBoundary from "./components/ErrorBoundary";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

function getLibrary(provider: ExternalProvider | JsonRpcFetchFunc) {
  return new Web3Provider(provider, "any");
}

const recaptchaSiteKey =
  process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY ||
  "6LdSUk0sAAAAAONrnZGxpjjVSwol6nEWOC0G-Kbw";

console.log(
  "reCAPTCHA site key:",
  recaptchaSiteKey ? recaptchaSiteKey : "REACT_APP_GOOGLE_RECAPTCHA_KEY not set"
);

// Verify the key format
if (!recaptchaSiteKey || !recaptchaSiteKey.startsWith("6L")) {
  console.error("Invalid reCAPTCHA site key format");
}

root.render(
  <ErrorBoundary>
    <GoogleOAuthProvider clientId="232957845996-ctig89g3o6uigoq4gu1pkil3fauv88gi.apps.googleusercontent.com">
      <React.StrictMode>
        <Web3ReactProvider getLibrary={getLibrary}>
          <App />
        </Web3ReactProvider>
      </React.StrictMode>
    </GoogleOAuthProvider>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();